/* @flow */
export default from './FlexTable'
export FlexTable, { SortDirection, SortIndicator } from './FlexTable'
export FlexColumn from './FlexColumn'



/** WEBPACK FOOTER **
 ** ./source/FlexTable/index.js
 **/